import { useContext } from "react";
import { LayoutContextType, LayoutActions } from "./LayoutContextTypes";
import { LayoutContext } from "./LayoutContext";

export function useLayoutContext() {
    const context = useContext<[LayoutContextType, (action: LayoutActions) => void] | undefined>(LayoutContext);
    if (!context) {
        throw new Error("useLayoutContext must be used within a LayoutContextProvider");
    }
    return context;
}
